import { Newest } from './Newest'
import { withNewest } from './withNewest'

const ConnectedRecommendedArticle = withNewest(Newest)

export { ConnectedRecommendedArticle as Newest }
